var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJeans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#4c4c4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.741 4.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.938,45.759l1.3-42.634H34.784l1.3,42.634",
    transform: "translate(-10.504 -3.125)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 10.406,
    height: 3.411,
    transform: "translate(15.608 42.634)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 10.406,
    height: 3.411,
    transform: "translate(0 42.634)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 3.035,
    y2: 28.991,
    transform: "translate(13.007 13.643)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.035,
    y2: 28.991,
    transform: "translate(9.972 13.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.531,5.625H11.813",
    transform: "translate(-10.165 -2.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.875,3.125V12.5",
    transform: "translate(-7.042 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.75,7.5v.171a3.106,3.106,0,0,0,2.341,2.984l3.989,1.108",
    transform: "translate(-5.54 -1.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.018,7.188v.6a3.106,3.106,0,0,1-2.341,2.984l-3.989,1.108",
    transform: "translate(-10.213 -1.645)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 0.694,
    cy: 0.682,
    rx: 0.694,
    ry: 0.682,
    transform: "translate(14.394 1.023)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 56,
    height: 55.067
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeans);
export default __webpack_public_path__ + "static/media/Jeans.50ff7975943d6501955d070cee660aac.svg";
export { ForwardRef as ReactComponent };